export const API_URL = "https://cookie-api.rok.gg";
// export const API_URL = "http://192.168.0.29:1337";
